import React from 'react';
import { Link } from 'react-router-dom';
import './GetInvolved.css';

const WAYS = [
  {
    icon: '🤝',
    iconBg: 'icon-bg-teal',
    cardClass: 'involved-card-volunteer',
    title: 'Volunteer With Us',
    desc: 'Lend your time, skills, and passion. Join field programs, digital campaigns, or corporate volunteering days.',
    btn: 'Get Involved',
    href: 'https://grantalife.com/',
    btnClass: 'btn-primary',
  },
  {
    icon: '🏢',
    iconBg: 'icon-bg-blue',
    cardClass: 'involved-card-partner',
    title: 'Corporate Partnership',
    desc: 'CSR-aligned partnerships that create shared value. Co-design programs, fund initiatives, and measure social ROI together.',
    btn: 'Partner With Us',
    to: '/contact',
    btnClass: 'btn-outline',
  },
];

export default function GetInvolved() {
  return (
    <section className="get-involved section" aria-labelledby="get-involved-heading">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Take Action</span>
          <h2 className="section-title" id="get-involved-heading">Ways to Get Involved</h2>
          <p className="section-subtitle">
            Whether you volunteer, partner with us, or spread the word — every action creates ripples of change in someone's life.
          </p>
        </div>

        <div className="involved-grid" role="list">
          {WAYS.map(w => (
            <div className={`involved-card ${w.cardClass}`} key={w.title} role="listitem">
              <div className={`involved-card-icon ${w.iconBg}`} aria-hidden="true">
                {w.icon}
              </div>
              <h3 className="involved-card-title">{w.title}</h3>
              <p className="involved-card-desc">{w.desc}</p>
              {w.href
                ? <a href={w.href} target="_blank" rel="noopener noreferrer" className={`btn ${w.btnClass}`}>{w.btn}</a>
                : <Link to={w.to} className={`btn ${w.btnClass}`}>{w.btn}</Link>
              }
            </div>
          ))}
        </div>

        <div className="cta-banner" role="complementary" aria-label="Newsletter and updates">
          <div className="cta-banner-content">
            <span className="cta-banner-label">Join 5,000+ Supporters</span>
            <h2 className="cta-banner-title">
              Together, We Can Do So Much More
            </h2>
            <p className="cta-banner-desc">
              Every hour volunteered, every story shared, every partnership formed — it all adds up to a community stronger than its challenges. Start your journey with Shine People Trust today.
            </p>
            <div className="cta-banner-actions">
              <a href="https://grantalife.com/" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg">
                Get Involved &rarr;
              </a>
              <Link to="/contact" className="btn btn-outline-white btn-lg">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
